export const navLinks = [
  { label: "平台功能", href: "#features" },
  { label: "内容板块", href: "#sections" },
  { label: "快讯流", href: "#flash" },
  { label: "服务", href: "#services" },
  { label: "玩法机制", href: "#how" },
  { label: "常见问题", href: "#faq" },
];

export const heroStats = [
  { value: "38", suffix: "个", label: "内容板块" },
  { value: "24", suffix: "h", label: "热点滚动更新" },
  { value: "156", suffix: "万", label: "每日话题浏览" },
  { value: "99", suffix: "%", label: "线索来源可溯源" },
];

export const heroTicker = [
  "爆料专区 · 新增线索 128 条",
  "吃瓜广场 · 实时热帖 4.2 万",
  "深扒专题 · 本周上新 16 期",
  "话题追踪 · 已关注 2.7 万话题",
  "热度榜单 · 每 10 分钟刷新",
  "订阅提醒 · 已推送 38 万次",
  "内容板块 · 覆盖 12 大领域",
];

export const features = [
  {
    icon: "ri-flashlight-line",
    title: "实时爆料",
    desc: "线索投递入口全天开放，热点出现后即时进入待核实队列，让你第一时间看到动态。",
    tag: "核心功能",
  },
  {
    icon: "ri-chat-smile-2-line",
    title: "吃瓜广场",
    desc: "按话题聚合成讨论区，同一件事的来龙去脉、各方观点集中在一处，不用来回翻找。",
    tag: "互动",
  },
  {
    icon: "ri-search-eye-line",
    title: "深度深扒",
    desc: "把零散线索整理成时间线、关系图与关键节点，帮你看清一件事的完整脉络。",
    tag: "专题",
  },
  {
    icon: "ri-radar-line",
    title: "话题追踪",
    desc: "关注感兴趣的人或事件，有新进展自动提醒，不必反复刷新页面。",
    tag: "订阅",
  },
  {
    icon: "ri-fire-line",
    title: "热度榜单",
    desc: "按讨论量、浏览量与更新速度综合排序，榜单定时刷新，热门内容一目了然。",
    tag: "榜单",
  },
  {
    icon: "ri-notification-3-line",
    title: "订阅提醒",
    desc: "支持站内与消息双通道提醒，可自定义推送频率，只收你真正关心的更新。",
    tag: "通知",
  },
];

export const contentSections = [
  {
    name: "娱乐风云",
    tag: "娱乐",
    count: "12,480 条话题",
    desc: "影视综与舞台动态的集中地，热度变化与讨论走向随时可见。",
    image:
      "https://readdy.ai/api/search-image?query=Minimalist%20editorial%20illustration%20symbolizing%20entertainment%20news%20buzz%2C%20warm%20cream%20background%2C%20vermilion%20red%20and%20amber%20gold%20geometric%20accents%2C%20abstract%20stage%20spotlight%20beams%2C%20subtle%20grain%2C%20lots%20of%20negative%20space%2C%20flat%20art%20direction%2C%20no%20text%2C%20no%20faces&width=800&height=600&seq=hl-sec-ent-01&orientation=landscape",
  },
  {
    name: "网红观察",
    tag: "网红",
    count: "8,930 条话题",
    desc: "创作者与直播间生态观察，从涨粉到带货的完整轨迹都能跟上。",
    image:
      "https://readdy.ai/api/search-image?query=Minimalist%20editorial%20illustration%20symbolizing%20internet%20creator%20livestream%20culture%2C%20warm%20cream%20background%2C%20vermilion%20red%20and%20amber%20gold%20geometric%20accents%2C%20abstract%20ring%20light%20and%20microphone%20shapes%2C%20subtle%20grain%2C%20negative%20space%2C%20flat%20art%20direction%2C%20no%20text%2C%20no%20faces&width=800&height=600&seq=hl-sec-creator-02&orientation=landscape",
  },
  {
    name: "体坛热榜",
    tag: "体育",
    count: "6,240 条话题",
    desc: "赛事焦点与场外话题并行，比分之外的故事同样值得围观。",
    image:
      "https://readdy.ai/api/search-image?query=Minimalist%20editorial%20illustration%20symbolizing%20sports%20hot%20topics%2C%20warm%20cream%20background%2C%20vermilion%20red%20and%20amber%20gold%20geometric%20accents%2C%20abstract%20motion%20arcs%20and%20ball%20shapes%2C%20subtle%20grain%2C%20negative%20space%2C%20flat%20art%20direction%2C%20no%20text%2C%20no%20faces&width=800&height=600&seq=hl-sec-sport-03&orientation=landscape",
  },
  {
    name: "财经人物",
    tag: "财经",
    count: "4,510 条话题",
    desc: "商业动向与人物经历的结构化整理，帮你看懂数字背后的故事。",
    image:
      "https://readdy.ai/api/search-image?query=Minimalist%20editorial%20illustration%20symbolizing%20business%20and%20finance%20figures%2C%20warm%20cream%20background%2C%20vermilion%20red%20and%20amber%20gold%20geometric%20accents%2C%20abstract%20rising%20bar%20chart%20and%20coin%20shapes%2C%20subtle%20grain%2C%20negative%20space%2C%20flat%20art%20direction%2C%20no%20text%2C%20no%20faces&width=800&height=600&seq=hl-sec-finance-04&orientation=landscape",
  },
  {
    name: "数码圈子",
    tag: "数码",
    count: "3,760 条话题",
    desc: "新机发布、测评争议与行业动态，科技圈的讨论同样精彩。",
    image:
      "https://readdy.ai/api/search-image?query=Minimalist%20editorial%20illustration%20symbolizing%20digital%20and%20gadget%20community%2C%20warm%20cream%20background%2C%20vermilion%20red%20and%20amber%20gold%20geometric%20accents%2C%20abstract%20circuit%20and%20device%20outlines%2C%20subtle%20grain%2C%20negative%20space%2C%20flat%20art%20direction%2C%20no%20text%2C%20no%20faces&width=800&height=600&seq=hl-sec-tech-05&orientation=landscape",
  },
];

export const flashUpdates = [
  {
    time: "09:42",
    tag: "娱乐",
    title: "某剧集口碑反转话题热度攀升，讨论量两小时翻倍",
    heat: "热度 96",
    status: "已核实",
  },
  {
    time: "10:05",
    tag: "网红",
    title: "直播间争议片段被重新剪辑传播，平台已补充完整时间线",
    heat: "热度 91",
    status: "跟进中",
  },
  {
    time: "10:38",
    tag: "体育",
    title: "赛后采访内容引发解读分歧，多方回应集中上线",
    heat: "热度 88",
    status: "已核实",
  },
  {
    time: "11:12",
    tag: "财经",
    title: "某公司人事变动传闻出现，公开资料已同步更新至专题页",
    heat: "热度 83",
    status: "待核实",
  },
  {
    time: "11:47",
    tag: "数码",
    title: "新品测评数据争议持续，测评方与原厂各发说明",
    heat: "热度 79",
    status: "跟进中",
  },
  {
    time: "12:20",
    tag: "娱乐",
    title: "联名合作物料被提前泄露，官方尚未正式回应",
    heat: "热度 74",
    status: "待核实",
  },
];

export const services = [
  {
    icon: "ri-user-line",
    name: "浏览用户",
    price: "免费",
    unit: "长期开放",
    desc: "看爆料、追话题、逛讨论区，基础浏览与话题追踪功能全部免费使用。",
    points: ["全板块自由浏览", "话题追踪不限量", "站内提醒基础推送", "吃瓜广场参与讨论"],
    highlight: false,
  },
  {
    icon: "ri-mic-line",
    name: "爆料作者",
    price: "创作者计划",
    unit: "申请入驻",
    desc: "面向愿意提供线索与整理内容的作者，提供发布通道、数据看板与内容扶持。",
    points: ["专属投递通道", "内容数据看板", "专题优先展示", "曝光与成长激励"],
    highlight: true,
  },
  {
    icon: "ri-links-line",
    name: "内容合作",
    price: "定制",
    unit: "按需沟通",
    desc: "面向媒体与品牌的合规合作方案，围绕话题运营与专题共建展开。",
    points: ["专题共建支持", "数据报告输出", "合规内容审查", "专属对接服务"],
    highlight: false,
  },
];

export const howSteps = [
  {
    step: "01",
    icon: "ri-radar-line",
    title: "热点发现",
    desc: "系统持续监测各板块讨论热度，异常升温的话题会被自动标记并推到前台。",
  },
  {
    step: "02",
    icon: "ri-shield-check-line",
    title: "线索核实",
    desc: "进入队列的线索先做来源核对与交叉比对，标注状态后再决定展示层级。",
  },
  {
    step: "03",
    icon: "ri-file-list-3-line",
    title: "内容成型",
    desc: "把核实后的信息整理成时间线与专题条目，补齐背景与关键节点，方便快速读懂。",
  },
  {
    step: "04",
    icon: "ri-refresh-line",
    title: "持续更新",
    desc: "话题有新进展时自动补充内容并刷新热度，关注的用户会收到对应提醒。",
  },
];

export const trustPoints = [
  {
    icon: "ri-shield-check-line",
    title: "来源可溯源",
    desc: "每条内容尽量标注公开来源与核实状态，让读者自己判断可信程度。",
  },
  {
    icon: "ri-eye-off-line",
    title: "隐私优先",
    desc: "不展示普通个人的敏感信息，涉及隐私的线索一律先拦截再处理。",
  },
  {
    icon: "ri-edit-2-line",
    title: "纠错通道",
    desc: "内容如有偏差可通过纠错入口反馈，核实后及时更正或下线。",
  },
  {
    icon: "ri-shield-star-line",
    title: "合规审核",
    desc: "上线前统一过一遍内容规范，不实信息与违规内容不会进入展示流程。",
  },
];

export const faqs = [
  {
    q: "黑料平台主要有哪些功能和内容板块？",
    a: "平台围绕爆料、吃瓜与深扒三类核心能力展开，配合话题追踪、热度榜单和订阅提醒。内容板块覆盖娱乐、网红、体育、财经、数码等十二个领域，方便按兴趣快速筛选。",
  },
  {
    q: "平台的内容是怎么更新的？多久更新一次？",
    a: "讨论热度实时监测，热点进入待核实队列后会尽快处理；热度榜单每十分钟刷新一次，专题内容按话题进展持续补充，全天候滚动更新。",
  },
  {
    q: "上面的信息可靠吗？平台如何保证真实性？",
    a: "所有内容先做来源核对与交叉比对，并在条目上标注核实状态；未通过核实的线索只会以「待核实」形式出现，同时保留纠错通道供读者反馈。",
  },
  {
    q: "浏览需要注册或者付费吗？",
    a: "基础浏览、话题追踪与站内提醒均免费开放，不需要付费。创作者计划与内容合作属于增值服务，按需申请即可。",
  },
  {
    q: "我可以在平台投稿或者提供线索吗？",
    a: "可以。平台设有全天开放的线索投递入口，提交后进入核实流程；创作者还可以申请入驻，获得专属通道与数据看板。",
  },
  {
    q: "遇到不实信息或者侵权内容怎么办？",
    a: "每条内容页都提供纠错与投诉入口，收到反馈后会启动复核流程，确认存在问题会及时更正、补充说明或下线处理。",
  },
];

export const footerColumns = [
  {
    title: "平台内容",
    links: ["娱乐风云", "网红观察", "体坛热榜", "财经人物", "数码圈子"],
  },
  {
    title: "平台服务",
    links: ["浏览用户", "创作者计划", "内容合作", "线索投递"],
  },
  {
    title: "平台玩法",
    links: ["话题追踪", "热度榜单", "订阅提醒", "深扒专题"],
  },
  {
    title: "帮助与规范",
    links: ["常见问题", "内容规范", "纠错通道", "联系我们"],
  },
];